import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Label,
  TextField,
  Icon,
  Button,
  Divider,
  Tooltip,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from 'mw-style-react';
import useIntl from 'useIntl';
import mes from './intl';
import '../../CreateRefBook.scss';

function RefBookSettings({ editMode, values, errors, handleOnChange }) {
  const t = useIntl();

  const handleAddItem = () => {
    const newFields = values.fields.slice();
    newFields.push({ value: '', title: '' });
    handleOnChange({ id: 'fields', value: newFields });
  };

  useEffect(() => {
    if (!values.fields.length) {
      handleAddItem();
    }
  }, []);

  const handleRemoveItem = (index) => {
    if (values.fields.length === 1) return;
    const newFields = values.fields.slice();
    newFields.splice(index, 1);
    handleOnChange({ id: 'fields', value: newFields, error: false });
    // очистка ошибок по удаленному полю
    setTimeout(
      () =>
        handleOnChange({
          id: `fields[${index}].value`,
          value: '',
          error: false,
        }),
      0
    );
    setTimeout(
      () =>
        handleOnChange({
          id: `fields[${index}].title`,
          value: '',
          error: false,
        }),
      0
    );
  };

  const handleItemChange = ({ index, id, value }) => {
    const newFields = values.fields.slice();
    newFields[index][id] = value;
    handleOnChange({ id: 'fields', value: newFields });
    setTimeout(
      () =>
        handleOnChange({
          id: `fields[${index}].${id}`,
          value: '',
          error: false,
        }),
      0
    );
  };

  const renderBookItem = (index, value, title) => {
    const valueErrKey = `fields[${index}].value`;
    const titleErrKey = `fields[${index}].title`;
    const isSingleItem = values.fields.length === 1;
    return (
      <div key={index} styleName="row item">
        <TextField
          id="value"
          styleName="row__field"
          bordered={true}
          value={value}
          error={!!errors[valueErrKey]}
          helperText={t(mes[errors[valueErrKey]])}
          placeholder="Value"
          onChange={(data) => handleItemChange({ index, ...data })}
        />
        <TextField
          id="title"
          styleName="row__field"
          bordered={true}
          value={title}
          error={!!errors[titleErrKey]}
          helperText={t(mes[errors[titleErrKey]])}
          placeholder="Title"
          onChange={(data) => handleItemChange({ index, ...data })}
        />
        <div onClick={() => handleRemoveItem(index)}>
          <Tooltip
            styleName="content__tooltip"
            value={isSingleItem ? t(mes.cantRemoveTheLast) : t(mes.remove)}
          >
            <Icon
              type="close"
              size="small"
              visibility={isSingleItem ? 'disabled' : 'visible'}
            />
          </Tooltip>
        </div>
      </div>
    );
  };

  const renderKeyValuesTable = () => (
    <Table paddingSize="small" styleName="table">
      <TableHead fixed={true}>
        <TableRow styleName="table__row" rowSize="small">
          <TableCell styleName="table__cell value">
            {t(mes.refBookValue)}
          </TableCell>
          <TableCell styleName="table__cell title">
            {t(mes.refBookTitle)}
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {values.fields.map((item, index) => (
          <TableRow key={index} styleName="table__row" rowSize="small">
            <TableCell styleName="table__cell value">
              <Label value={item.value} />
            </TableCell>
            <TableCell styleName="table__cell title">
              <Label value={item.title} />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );

  return (
    <div styleName="row">
      {editMode ? (
        <>
          <div styleName="row">
            <Label
              styleName="row__label"
              fontWeight="semibold"
              value={t(mes.refBookName)}
            />
            <TextField
              id="title"
              styleName="row__field"
              autoFocus={true}
              bordered={true}
              value={values.title}
              error={!!errors.title}
              helperText={t(mes[errors.title])}
              onChange={handleOnChange}
            />
          </div>
          <Divider />
          <div styleName="row">
            <Label
              styleName="row__label"
              fontWeight="semibold"
              value={t(mes.refBookValues)}
            />
          </div>
          <div styleName="row">
            {values.fields.map((item, index) =>
              renderBookItem(index, item.value, item.title)
            )}
            <Label
              error={true}
              fontSize="small"
              value={t(mes[errors.fields])}
              visibility={errors.fields ? 'visible' : 'hidden'}
            />
            <Button
              styleName="row__btn"
              type="text"
              icon="plus"
              fontWeight="normal"
              label={t(mes.addRefBookValue)}
              onClick={handleAddItem}
            />
          </div>
        </>
      ) : (
        renderKeyValuesTable()
      )}
    </div>
  );
}

RefBookSettings.propTypes = {
  editMode: PropTypes.bool,
  values: PropTypes.object,
  errors: PropTypes.object,
  handleOnChange: PropTypes.func,
};

export default RefBookSettings;
